import { render } from "./OrderChairman.vue?vue&type=template&id=9e3441fe&scoped=true"
import script from "./OrderChairman.vue?vue&type=script&lang=js"
export * from "./OrderChairman.vue?vue&type=script&lang=js"

import "./OrderChairman.vue?vue&type=style&index=0&id=9e3441fe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9e3441fe"

export default script